import MaterialTable from '@material-table/core'
import React, { useMemo } from 'react';
import fileIcon from "../../../../../img/icons/FileTableIcon.svg";
import { Image } from 'react-bootstrap';
import { monthsArray } from '../../../../stores/StratProject/StrategyStore';
import { observer } from 'mobx-react';
import { useStore } from '../../../../stores/StoreHelpers';
import TooltippedElement from '../../../common/TooltippedElement';
import { localization } from '../../../../helpers/table';

export const ProjectsFacts = observer(({activeMilestoneSetter, projectFacts}) => {
  const store = useStore()

  return <MaterialTable
    data={projectFacts}
    localization={localization}
    columns={[
      {
        title: 'Название вехи',
        field: 'name',
        cellStyle: {
          borderBottom: '1px solid #d4d4d4',
          minWidth: window.innerWidth * 0.17
        }
      },
      {
        title: 'Фактический результат',
        field: 'result',
        cellStyle: {
         borderBottom: '1px solid #d4d4d4',
         minWidth: window.innerWidth * 0.17
        }
      },
      {
        title: 'Срок (план)',
        field: 'datePlan',
        cellStyle: {
         borderBottom: '1px solid #d4d4d4'
        },
        render: rowData => <p>{rowData.monthPlan ? `${monthsArray[rowData.monthPlan - 1]}, ${rowData.yearPlan}` : '-'}</p>
      },
      {
        title: 'Срок (факт)',
        field: 'dateFact',
        cellStyle: {
         borderBottom: '1px solid #d4d4d4'
        },
        render: rowData => <p>{rowData.monthFact ? `${monthsArray[rowData.monthFact - 1]}, ${rowData.yearFact}` : '-'}</p>
      },
      {
        title: 'УГТ (план)',
        field: 'trlId',
        cellStyle: {
         borderBottom: '1px solid #d4d4d4'
        },
        render: rowData => rowData.trlId && store.strategies?.trls ?
          <TooltippedElement 
            iconSize={'16px'}
						tooltip={
							store.strategies?.trls?.find(trl => trl.id === rowData.trlId)?.descr
						}>
             {rowData.trlId}   
          </TooltippedElement> : 
          '-'
      },
      {
        title: 'УГТ (факт)',
        field: 'trlFactId',
        cellStyle: {
         borderBottom: '1px solid #d4d4d4'
        },
        render: rowData => rowData.trlFactId && store.strategies?.trls ?
          <TooltippedElement 
            iconSize={'16px'}
						tooltip={
							store.strategies?.trls?.find(trl => trl.id === rowData.trlFactId)?.descr
						}>
             {rowData.trlFactId}   
          </TooltippedElement> : 
          '-'
      }, 
      {
        title: 'Ответственный',
        field: 'personInCharge',
        render: rowData => rowData.personsInCharge && rowData.personsInCharge.length > 0 ? rowData.personsInCharge[0].displayName : '-',
        cellStyle: {
         borderBottom: '1px solid #d4d4d4'
        }
      },
      {
        title: 'Проект',
        field: 'projectNum',
        cellStyle: {
         borderBottom: '1px solid #d4d4d4'
        },
        render: rowData => <div>{rowData.projs[0].fullNumber}</div>
      },
      {
        title: 'Док.',
        field: 'files',
        cellStyle: {
         borderBottom: '1px solid #d4d4d4'
        },
        render: rowData => <div
									className='d-flex align-items-center gap-1'
									style={{ color: '#0D6EFD', cursor: 'pointer' }}
									onClick={() => {
										activeMilestoneSetter(rowData)
									}}
								>
									<Image src={fileIcon} style={{ width: 16 }} />
									{rowData.files?.length ?? 0}
								</div>
      }
    ]}
    options={{
        ...options,
        rowStyle: (data, index) => ({
          backgroundColor: index % 2 === 0 ? '#F2F2F2' : '#fff',
        }),
        headerStyle: {
          fontFamily: 'inherit',
           borderBottom: '1px solid #d4d4d4'
        }
      }
    }
  />
})

const options = {
  filtering: false,
  paging: false,
  search: false,
  sorting: false,
  draggable: false,
  toolbar: false,
  headerStyle: {
    height: 50,
    color: '#7F7F7F',
    borderBottom: '1px solid #D4D4D4'
  },
  rowStyle: {
    borderBottom: '1px solid #D4D4D4'
  }
}